import type { FeatureVariation, FStory } from './types';

export { FULLSTORY_EXCLUDE_CLASS, FULLSTORY_MASK_CLASS } from './constants';

export const setFeatureVariationsToFullstory = (
  featureVariations: FeatureVariation[]
) => {
  try {
    const FStory: FStory = window.FStory as FStory;
    if (FStory && featureVariations?.length > 0) {
      const value =
        featureVariations
          .map((feature) => `${feature.name}:${feature.index}`)
          .join(';') + ';';

      FStory('trackEvent', {
        name: 'AB Features Variations',
        properties: { value: value },
      });
    }
  } catch (_e) {
    // Fail silently
  }
};
